import { useAppNotificationContext } from "./app-notification.context";

import "./app-notification.style.less";

const AppNotificationHandler = () => {
  const { contextHolder } = useAppNotificationContext();

  return <>{contextHolder}</>;
};

export default AppNotificationHandler;
